import { Dialog } from "@mui/material";
import card from "Assets/images/card.jpg";
import React, { useState } from "react";
import Styles from "./ViewCard.module.scss";

const GreetingCard = ({ value, signature, video_url }) => {
  const [show, setShow] = useState(false);
  return (
    <div className="my-5">
      {video_url && (
        <a
          className="d-inline-block mb-3"
          href="#"
          onClick={(e) => {
            e.preventDefault();
            setShow(true);
          }}
        >
          {"Show video message"}
        </a>
      )}
      <Dialog open={show} onClick={() => setShow(false)}>
        <video
          controls
          src={video_url}
        ></video>
      </Dialog>
      <div className={Styles.card}>
        <div className={Styles.inner}>
          <img className={Styles.image} src={card} alt="Card" />
          <div className={Styles.message}>
           {/* <div dangerouslySetInnerHTML={{__html: value}}></div> */}
           {value}
          </div>
          <span className={Styles.signature}>
            {signature}
          </span>
        </div>
      </div>
    </div>
  );
};

export default GreetingCard;